<a
    [routerLink]="[]"
    [queryParams]="facetQueryParam"
    i18n-queryParamsHandling
    [attr.aria-label]="ariaLabel"
    [tabindex]="isExpanded ? null : -1"
    (click)="addFilterCrawlableLinks($event)"
    (keydown.space)="addFilterCrawlableLinks($event)"
    [attr.data-test-id]="dataTestId">
    <ng-content></ng-content>
</a>
